import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const number = params.get("number");

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-olive-500/15 border border-olive-500/40 text-olive-500">
        <Check size={28} />
      </div>
      <div className="eyebrow mt-6">Confirmed</div>
      <h1 className="mt-3 font-display text-5xl text-ink-900">Your order is on its way.</h1>
      <p className="mt-4 text-ink-700">Order <span className="font-mono tracking-wider">#{number}</span> — a confirmation has been sent to your inbox.</p>
      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link to={`/track?n=${number}`} className="btn-primary-ink px-8 py-4 text-xs uppercase tracking-[0.28em]" data-testid="track-my-order">Track order</Link>
        <Link to="/shop" className="btn-gold-outline px-8 py-4 text-xs uppercase tracking-[0.28em]">Continue shopping</Link>
      </div>
    </div>
  );
}
